import React from 'react';
const WrappedRoutes = React.lazy(() => import("./WrapperRoutes"));


const Router = () => {

  return (
   <React.Fragment>
     <WrappedRoutes />
   </React.Fragment>
  );
};

export default Router;
